


























import { Vue, Component } from "@/shared/vuepack";
import Finish from "@/employee/components/onboarding/balance-transfer/Finish.vue";

@Component({
  components: {
    Finish
  }
})
export default class RolloverFinish extends Vue {}
